<template>
  <div class="menuFrame">
    <!-- <loading :active.sync="isLoading"></loading> -->

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
            <em name="Exhibition"></em><span>/</span
            ><span
              @click.prevent="toCampaignList"
              style="color: #1a73e8"
              class="pointer px-0"
              >官方行銷活動</span
            ><span>/</span
            ><span class="px-0">{{ EventDetail.EventName }} </span>
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox">
          <h1>{{ EventDetail.EventName }}</h1>

          <p class="formTitle mt-5">活動說明</p>
          <p class="mb-4 mt-1 event-desc" v-html="EventDetail.EventDesc"></p>

          <p class="formTitle mt-3">開放時間</p>
          <p class="mb-4 mt-1">
            {{ formatDate(EventDetail.RegStartTime) }} -
            {{ formatDate(EventDetail.RegEndTime) }}
          </p>

          <p class="formTitle mt-3" v-if="EventDetail.EventWarning">注意事項</p>
          <p class="mb-4 mt-1" v-html="EventDetail.EventWarning"></p>
          <!-- <div class="d-flex align-items-center justify-content-start mb-4">
            <div
              class="btn btn-lg btn-primary text-nowrap"
              @click.prevent="toGiftSelect"
            >
              我要報名
            </div>
          </div> -->

          <div class="mt-5">
            <div class="d-flex align-items-center justify-content-start mb-4">
              <div v-if="isStart">
                <div v-if="booth_sqm >= minBoothQty">
                  <div v-if="EventDetail.RegLimit - EventDetail.RegCount <= 0">
                    <div class="btn btn-lg btn-primary text-nowrap disabled">
                      已達報名上限
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="btn btn-lg btn-primary text-nowrap"
                      @click.prevent="toCampaignGiveaway"
                    >
                      我要報名
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="btn btn-lg btn-primary text-nowrap disabled">
                    未達資格
                  </div>
                </div>
              </div>
              <div v-else-if="!isStart">
                <div v-if="Eventdateline">
                  <div class="btn btn-lg btn-primary text-nowrap disabled">
                    活動已截止
                  </div>
                </div>
                <div v-else-if="!Eventdateline">
                  <div class="btn btn-lg btn-primary text-nowrap disabled">
                    活動尚未開放
                  </div>
                </div>
              </div>
            </div>

            <div class="alert" v-if="!Eventdateline">
              <p>
                1. 參展攤位數需達
                <span class="red"> {{ EventDetail.BoothThreshold }} </span
                >個以上 ，才可參加本活動
              </p>
              <p>
                2. 您已經報名
                <span class="red">{{ EventDetail.RegCount }}</span>
                個贈品，還可以選擇
                <span class="red">{{
                  EventDetail.RegLimit - EventDetail.RegCount
                }}</span>
                個贈品參加本活動
              </p>
            </div>

            <div
              v-if="RegisterListNum > 0"
              class="mt-4"
              style="font-size: 22px"
            >
              <i class="fas fa-chevron-circle-down text-warning"></i>
              已報名產品
            </div>

            <div
              class="row"
              v-if="booth_sqm >= minBoothQty && (isStart || Eventdateline)"
            >
              <div
                class="col-sm-3 mb-2"
                v-for="(item, index) in RegistrationsList"
                :key="index"
              >
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="imgstyle text-center">
                      <img
                        :src="`${item.ProductImage}`"
                        class="img-fluid mt-2"
                        width="130px"
                      />
                    </div>
                    <ul class="list-group list-group-flush mx-2">
                      <div class="mt-3 mb-2 h5">
                        <strong>{{ item.ProductName }}</strong>
                      </div>

                      <p class="gray">規格：{{ item.ProductSpec }}</p>

                      <p class="gray">提供數量：{{ item.ProvidedCount }}</p>

                      <p class="gray">市價：{{ item.Price }}</p>

                      <div class="card-footer mt-3 bg-white" v-if="isStart">
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                        >
                          <div
                            class="btn btn-primary py-2"
                            @click.prevent="EditPromotion(item.RegID)"
                          >
                            編輯
                          </div>
                          <div
                            class="btn btn-secondary ml-3 py-2"
                            @click.prevent="DelCampaign(item.RegID)"
                          >
                            取消
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "行銷活動資訊 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      eventId: "",
      booth_sqm: "",
      minBoothQty: "",
      maxProductQty: "",
      RegisterListNum: "",

      inputDescHidden: "",
      inputDescHidden2: "",
      inputDescName2: "",
      einputDescName2: "",
      einputDescName: "",
      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      ShowRegiter: false,

      OpendateString: "",
      ClosedateString: "",
      OpenSec: "",
      OpenMin: "",
      CloseSec: "",
      CloseMin: "",
      inputDescName: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      LocalExh: true,

      isStart: true,
      eventType: "",
      RegistrationsList: [],
      Eventdateline: false,
    };
  },

  watch: {},

  methods: {
    toCampaignList() {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaign?no=${vm.RegNo}`;
    },

    toCampaignGiveaway() {
      const vm = this;

      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignGiveawayAdd?no=${vm.RegNo}&eventId=${vm.eventId}&eventType=2`;
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);

      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();

      // 使用 padStart(2, '0') 確保時分秒固定兩位數
      const hh = date.getHours().toString().padStart(2, "0");
      const mm = date.getMinutes().toString().padStart(2, "0");
      const ss = date.getSeconds().toString().padStart(2, "0");

      return `${y}/${m}/${d} ${hh}:${mm}:${ss}`;
    },
    toGiftSelect() {
      const vm = this;

      if (vm.booth_sqm >= vm.minBoothQty) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignGiveawayAdd?no=${vm.RegNo}&eventId=${vm.eventId}&eventType=2`;
      } else {
        alert("您報名的實體攤位數需高於活動指定攤位數才可進行報名。");
      }
    },

    EditPromotion(id) {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignGiveawayEdit?no=${vm.RegNo}&eventId=${vm.eventId}&regId=${id}&eventType=2`;
    },

    DelCampaign(id) {
      const vm = this;

      if (confirm("請確認要取消推廣此活動？")) {
        const url = `/ApiMarketingCampaign/MarketingEvents/CancelRegistration/${id}?type=${vm.eventType}`;

        axios
          .delete(url, {})
          .then(function (response) {
            const res = response.data;

            // 邏輯判定
            if (res.Code == 200) {
              alert("已成功取消報名");
              window.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignDetail?&no=${vm.RegNo}&eventId=${vm.eventId}&eventType=${vm.eventType}`;
            } else if (res.Code == 252) {
              // 雖然文件沒寫，但保留 CSRF 失敗直接導回官網的邏輯
              window.location.href = `https://www.chanchao.com.tw/`;
            } else {
              // 其他錯誤 Code 顯示後端回傳的 Message
              alert(res.Message || "系統忙碌中，請稍後再試！");
            }
          })
          .catch((err) => {
            console.error("API Error:", err);
          });
      }
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    const urlParams = new URLSearchParams(window.location.search);

    // 2. 直接用 get 抓取對應的名稱
    vm.RegNo = urlParams.get("no");
    vm.eventId = urlParams.get("eventId");
    vm.eventType = urlParams.get("eventType");

    // console.log(vm.RegNo)

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.ExhLogo}`;
        vm.ExhBegin = response.data.ExhBegin;
        vm.ExhEnd = response.data.ExhEnd;
        vm.ExhVenue = response.data.ExhVenue;
        vm.eExhVenue = response.data.eExhVenue;
        let ExpoLocation = response.data.Data.ExpoLocation;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }
      });

    //取得活動總資料

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Gift/Registrations/${vm.eventId}/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        console.log(response);
        vm.RegistrationsList = response.data.Data;
        vm.RegisterListNum = vm.RegistrationsList.length;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/Detail/${vm.RegNo}/${vm.eventId}?type=${vm.eventType}&lang=${vm.lang}`,
      )
      .then((response) => {
        vm.EventDetail = response.data.Data;
        vm.minBoothQty = response.data.Data.BoothThreshold;
        // 開啟時間判定;
        let openTime = new Date(vm.EventDetail.RegStartTime).getTime();
        let closeTime = new Date(vm.EventDetail.RegEndTime).getTime();
        const nowTime = Date.now();

        if (nowTime < openTime) {
          // 1. 活動未開始
          vm.isStart = false;
          vm.Eventdateline = false;
        } else if (nowTime >= openTime && nowTime <= closeTime) {
          // 2. 活動進行中 (開始了且尚未結束)
          vm.isStart = true;
          vm.Eventdateline = false;
        } else if (nowTime > closeTime) {
          // 3. 活動已截止 (超過結束時間)
          vm.isStart = false;
          vm.Eventdateline = true;
        }
      });

    //實體攤位數
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)
        vm.booth_sqm = response.data.Data.booth_sqm;
      });
  },
};
</script>

<style lang="scss">
.event-desc ol {
  margin-left: 20px; /* 控制外邊距 */
}
</style>
